<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter1">
<h1><a id="page_19"></a><a href="#/003toc#ch1">Totally Awesome Veggie Stock</a></h1>
<p class="noindent">Vegetable stock, rich in flavor, can be frozen for use in soups, stews, or vegetarian chilies. A slow cooker takes the mundane task of making stock and makes it simple by allowing you to pile everything into the cooker and let it slowly simmer for hours. You just need to strain the goodness into refrigerator or freezer containers for later use.</p>
<p class="noindent">¼ cup olive oil</p>
<p class="noindent">2 large sweet onions, such as Vidalia, coarsely chopped</p>
<p class="noindent">4 large carrots, cut into 1-inch chunks</p>
<p class="noindent">4 stalks celery with leaves, cut into 2-inch pieces</p>
<p class="noindent">4 medium parsnips, cut into 1-inch chunks</p>
<p class="noindent">8 ounces cremini mushrooms, quartered</p>
<p class="noindent">2 tablespoons tomato paste</p>
<p class="noindent">1 bunch Swiss chard, cut into 1-inch pieces (about 3 cups)</p>
<p class="noindent">2 teaspoons dried thyme</p>
<p class="noindent">1 bay leaf</p>
<p class="noindent">2 teaspoons salt</p>
<p class="noindent">½ teaspoon whole black peppercorns</p>
<p class="noindent">2 cups water</p>
<p class="noindent">put all the ingredients into the insert of a 5- to 7-quart slow cooker and toss to combine. Cover and cook on high for 5 hours or on low for 8 to 10 hours.</p>
<p class="noindent">remove the cover and take out the large pieces of vegetables with a slotted spoon. Strain the stock through a fine-mesh sieve and discard the solids.</p>
<p class="noindent">skim off any fat from the top of the stock. Refrigerate for up to 5 days or freeze for up to 6 months.</p>
<p class="noindent">makes about 8 cups</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007-chapter1.vue?370f3a26